<template>
  <div class="apps-promotion">
    <div class="panel-header">
      <h3 class="panel-header__title">推广管理</h3>
      <span class="panel-header__subtitle">PROMOTION MANAGEMENT</span>
      <a class="panel-header__export" v-if="exportUrl" :href="exportUrl">导出</a>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">
        推广管理
        <up-button type="primary" class="fr" @click="operatePromotion('add')"><b>+&nbsp;</b>新增推广</up-button>
      </h3>
      <div class="panel-content__select-list">
        <span class="panel-content__label">状态：</span>
        <up-select class="panel-content__select-item is-small" v-model="status" :data="statusList" clearable></up-select>
        <span class="panel-content__label">时间：</span>
        <ny-date-range class="panel-content__select-item" shortcut v-model="date"
                       @change="handleDateChange"></ny-date-range>
        <!--        <up-date-picker class="mr5" v-model="date" type="daterange" range-separator="至" placeholder="请选择日期范围"></up-date-picker>-->
        <up-input class="panel-content__select-item" v-model="keyword" placeholder="推广名称或ID"></up-input>
        <up-button type="primary" @click="searchPromotion()">查询</up-button>
        <div class="fr mr20">
          <up-button type="primary" @click="batchStartAndStopPromotion(selectedIds, true, true)" :loading="starting">
            批量开启
          </up-button>
          <up-button class="is-warning" type="primary" @click="batchStartAndStopPromotion(selectedIds, true, false)"
                     :loading="stopping">批量暂停
          </up-button>
        </div>
      </div>
      <div class="panel-content__table-wrap">
        <up-table class="panel-content__table" :page="page"
                  :widthColumns="{ status_msg: 100 }" :slotContents="['status_msg']"
                  align="center" show-overflow-tooltip selection pagination @cell-click="handleCellClick"
                  @up:selection-change="handleUpSelectChange" @up:current-change="({ currentPage }) => searchPromotion(currentPage)"
                  @up:size-change="searchPromotion()">
          <template slot="status_msg:content" slot-scope="{ row }">
            <div class="panel-content__table-status-box">
              <span class="panel-content__table-status" :class="{'is-active' : row.status_msg === '已启用'}"></span>
              <span>{{ row.status_msg }}</span>
            </div>
          </template>
          <template slot="up:operate">
            <up-table-column width="60" fixed="right" label="开关">
              <template slot-scope="{ row, $index }">
                <up-switch v-if="row.status !== 2" :value="row.status === 1"
                           @change="startAndStopPromotion(row, $index)"></up-switch>
              </template>
            </up-table-column>
            <up-table-column width="204" fixed="right" label="操作">
              <template slot-scope="{ row }">
                <div>
                  <up-button v-if="row.status === 0" class="is-edit" size="small" type="primary"
                            @click="operatePromotion('edit', row)">编辑
                  </up-button>
                  <up-button class="is-view" size="small" type="primary" @click="operatePromotion('view', row)">查看
                  </up-button>
                  <!--<up-button class="is-mini" size="small" type="primary" @click="startAndStopCreation(row, $index)" :loading="loadings[$index]">开始</up-button>-->
                  <up-button v-if="row.status !== 2" class="is-remove" size="small" type="primary"
                            @click="removePromotion(row)">停止
                  </up-button>
                  <up-button class="is-mini" size="small" type="primary" @click="operatePromotion('copy', row)">复制
                  </up-button>
                </div>
              </template>
            </up-table-column>
          </template>
        </up-table>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { mapActions } from 'vuex'
// import { get, capturedGet, capturedRemove, capturedPost } from '@/agent/http'
import { BASE_URL } from '@/global/util/constants'
import { NyDateRange } from '@/global/components'

export default {
  name: 'promotion',
  components: { NyDateRange },
  data () {
    return {
      platform: '',
      statusList: [],
      statusMap: {},
      status: '',
      date: [],
      keyword: '',
      page: new this.$page(),
      selectedIds: [],
      starting: false,
      stopping: false,
      loadings: [],
      refuse: {
        visible: false,
        reason: [],
        image: ''
      }
    }
  },
  computed: {
    exportUrl () {
      const params = { page: 1, per_page: 5000, ...this.getRequestParams() }
      return BASE_URL + `/${this.platform}/apps-promotion/export?` + qs.stringify(params)
    }
  },
  methods: {
    ...mapActions([
      'promotion/getPromotions',
      'promotion/removePromotion',
      'promotion/batchStartAndStopPromotion',
      'promotion/getSelectData'
    ]),
    handleDateChange () {
    },
    // 新增推广
    operatePromotion (type, row) {
      this.$router.push({ path: `/promotion/${type}${type !== 'add' ? '/' + row.id : ''}` })
    },
    getRequestParams () {
      const { status, keyword, date } = this
      const params = { }
      if (keyword) { params.search_content = keyword }
      if (status) { params.status = status }
      if (date && date.length === 2) { params.datepicker = date.join(' ~ ') }
      return params
    },
    // 查询推广
    searchPromotion (currentPage = 1) {
      this.page.currentPage = currentPage
      const params = this.getRequestParams()
      this.getPromotions(params)
    },
    // 0 暂停中, 1 投放中, 2 已停止
    async startAndStopPromotion (row, index) {
      this.batchStartAndStopPromotion([row.id], false, row.status === 0, index)
    },
    async removePromotion (row) {
      this.$msgbox({
        title: '温馨提示',
        message: `确定要删除ID为 “${row.id}” 的推广吗？`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            const [err, res] = await this['promotion/removePromotion']({ platform: this.platform, id: row.id })
            instance.confirmButtonLoading = false;
            if (err || res.code !== 1) {
              this.$message({ type: 'error', message: '删除推广失败！' })
            } else if (res.code === 1) this.$message({ type: 'success', message: '删除推广成功！' })
            done()
          } else {
            done();
          }
        }
      }).then(_ => {
        this.getPromotions()
      })
    },
    handleCellClick (row, column) {
      if (column.property !== 'verify_msg' || row.verify !== 2) return
      this.refuse.visible = true
      this.refuse.reason = (row.verify_message || '').split(/[\n↵]/g)
      this.refuse.image = row.verify_msg_pic
    },
    handleUpSelectChange ({ selection, selectAll }) {
      this.selectedIds = selection.map(v => v.id)
    },
    // 批量开启/暂停广告组
    async batchStartAndStopPromotion (ids, batch, isStart, index) {
      if (batch) {
        if (!ids.length) {
          return this.$message.error(`你还没有选中要批量${isStart ? '开启' : '暂停'}的推广`)
        }
      }

      let text = isStart ? '开启' : '暂停'
      const status = isStart ? 'starting' : 'stopping'
      if (batch) {
        this[status] = true
        text = '批量' + text
      } else {
        this.loadings.splice(index, 1, true)
      }

      const [err, res] = await this['promotion/batchStartAndStopPromotion']({ platform: this.platform, isStart, ids })
      if (batch) {
        this[status] = false
      } else {
        this.loadings.splice(index, 1, false)
      }
      if (err || res.code !== 1) {
        this.$message.error(`${text}推广失败！`)
      } else {
        this.$message.success(`${text}推广成功！`)
        this.getPromotions()
      }
    },
    async getPromotions (params = {}) {
      this.page.loading = true
      const { pageSize, currentPage } = this.page
      const [, { data: { header, data: { data: { data, total } } } }] = await this['promotion/getPromotions']({
        platform: this.platform,
        params: {
          per_page: pageSize,
          page: currentPage,
          ...params
        }
      })
      this.page.setData({ header, data, total })
      this.loadings = Array.from({ length: data.length }, Boolean)
    },
    async getSelectData () {
      const [, { data: { status: statusList } }] = await this['promotion/getSelectData']({ platform: this.platform })
      this.statusList = statusList
      this.statusMap = statusList.reduce((prev, cur) => {
        prev[cur.value] = cur.name
        return prev
      }, {})
    }
  },
  created () {
    this.platform = this.$route.meta.platform
    this.getSelectData()

    const { name, value } = this.$route.query
    if (name && value) {
      this.key = value
      this.value = name
      this.getPromotions({ [value]: name })
    } else {
      this.getPromotions()
    }
  }
}
</script>

<style lang="scss">
  @include b(apps-promotion) {
    //body
  }
</style>
